import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { v4 as SessionID } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class PrequoteApprovalService {

  public _PrequoteApproval = environment.PrequoteApproval;
  public _PrequoteReport = environment.PrequoteReport;
  public _httpOptions;
  public sessionId : string
  constructor(private http: HttpClient) { 
    this.sessionId = sessionStorage["SessionId"];
  this._httpOptions = {
    headers: new HttpHeaders({ 'SessionId':this.sessionId })
  };
  
}

GetPageInitializeDetails(): Observable<any>{
   

  var Query = this._PrequoteApproval;
  // console.log(Query);
  return this.http.get<{ data: any }>(Query,this._httpOptions);
}
GetById(customersitecode:string): Observable<any>{
 

  var Query = this._PrequoteApproval + '/GetById' +'/'+ customersitecode ;
  // console.log(Query);
  return this.http.get<{ data: any }>(Query,this._httpOptions);
}
GetReportPageInitializeDetails(): Observable<any>{
   

  var Query = this._PrequoteApproval+"/GetReportPageInitializeDetails";
  // console.log(Query);
  return this.http.get<{ data: any }>(Query,this._httpOptions);
}

GetReport(customersitecode:object): Observable<any>{
   

  var Query = this._PrequoteReport+"/Print";
  // console.log(Query);
  //return this.http.get<{ data: any }>(Query,this._httpOptions);
  return this.http.post(Query,customersitecode, { headers: new HttpHeaders({ 'SessionId':this.sessionId }),responseType: 'blob' });

}

}
